import styles from './FormalOfferCard.module.css';
import {
  getDurationInMonths,
  getProductName,
} from '../../helpers/product.helpers';
import { useNumberFormat } from '../../hooks/useNumberFormat';
import { TGetFormalOffersResponse } from '../../types';
import IconWithText from '../IconWithText/IconWithText';

type TProps = Pick<
  TGetFormalOffersResponse['data']['formal_offers'][number],
  | 'product_type'
  | 'duration'
  | 'max_amount'
  | 'interest_rates'
  | 'withdrawal_fee_percentage'
>;

const FormalOfferCard = ({
  product_type,
  duration,
  max_amount,
  interest_rates,
  withdrawal_fee_percentage,
}: TProps) => {
  const { formatCurrency, formatPercentage } = useNumberFormat();

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{getProductName(product_type)}</h3>
      <ul className={styles.detailsList}>
        <li className={styles.detailsListItem}>
          <IconWithText icon="calendar">
            Term length:{' '}
            <span className={styles.detailValue}>
              {getDurationInMonths(duration)}
              {' months'}
            </span>
          </IconWithText>
        </li>
        <li className={styles.detailsListItem}>
          <IconWithText icon="pound">
            Offer amount:{' '}
            <span className={styles.detailValue}>
              {formatCurrency(max_amount)}
            </span>
          </IconWithText>
        </li>
        <li className={styles.detailsListItem}>
          <IconWithText icon="percent">
            Interest rate:{' '}
            <span className={styles.detailValue}>
              {formatPercentage(interest_rates[0].rate)}
            </span>
          </IconWithText>
        </li>
        {withdrawal_fee_percentage ? (
          <li className={styles.detailsListItem}>
            <IconWithText icon="percent">
              Withdrawal fee:{' '}
              <span className={styles.detailValue}>
                {formatPercentage(withdrawal_fee_percentage)}
              </span>
            </IconWithText>
          </li>
        ) : null}
      </ul>
    </div>
  );
};
export default FormalOfferCard;
